import signIn from './signIn'
import base from './base'
import prompt from './prompt'
import button from  './button'
import title from './title'
import download from './download'
import label from './label'
import placeholer from './placeholder'
import lang from './lang'

export default {
    signIn,
    base,
    prompt,
    button,
    title,
    download,
    label,
    placeholer,
    lang
}
